export default __webpack_public_path__ + "static/media/user-summary_default-banner.6bca83e6.png";